<template>
	<div class="Modal">
		<button class="Modal-close-button" type="button" aria-label="Close modal" @click="onClickClose">×
		</button>
		<form method="post" action="/" @submit="onSubmitForm">
			<h1 class="thermo">ANNULEREN OPDRACHT van {{ data.companyname }}</h1>
			<label>Reden van annuleren</label>
			<textarea
				ref="focusTrap"
				class="TextField"
				name="text"
				placeholder="Typ hier de reden van annuleren"
				v-model="values.reason"
			></Textarea>
			<Button :primary="true" type="submit" ref="submitButton">ANNULEREN</Button>
		</form>
	</div>
</template>

<script>
import Button from "@/components/Button";
import {mapActions} from "vuex";

export default {
	components: {
		Button
	},

	props: {
		data: Object,
		project: Object
	},

	data() {
		return {
			values: {
				reason: "",
				reschedule: false
			}
		};
	},

	methods: {
		...mapActions({
			cancelUitvoering: "projects/cancelUitvoering",
			refreshProjectMapMarker: "projects/refreshProjectMapMarker"
		}),

		onSubmitForm(event) {
			event.preventDefault();

			const button = this.$refs.submitButton;

			button.disable();
			this.cancelUitvoering({
				id: this.project.id, ...this.values
			}).then(result => {
				button.enable();
				this.$notify({
					group: "app",
					title: "Opdracht annuleren",
					type: "success",
					text: `Opdracht geanuleerd voor ${this.data.companyname}`
				});
				this.refreshProjectMapMarker({id: this.project.id});
				this.$events.emit("map/closePopup");
				this.$emit("close");
			}).catch((error) => {
				button.enable();
				this.$notify({
					group: "app",
					title: "Opdracht annuleren",
					type: "error",
					text: error
				});
			});
		},

		onClickClose() {
			this.$emit("close");
		}
	},

	mounted() {
		this.$refs.focusTrap.focus();
	}
};
</script>
